'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { loginUserAction } from '@bts-web/core-features/auth';
import { isValidCompliancePolicy } from '@bts-web/utils-auth';

type SearchParams = Promise<{ [key in string]?: string | string[] }>;

interface PageProps {
  searchParams: SearchParams;
}

export function AuthTrigger({ searchParams }: PageProps) {
  const router = useRouter();

  useEffect(() => {
    const performLogin = async () => {
      const searchParamsData = await searchParams;

      const rawOtt = searchParamsData.ott;

      const rawRedirect = searchParamsData['redirect_url'];

      const rawRole = searchParamsData.role;

      const rawBusinessId = searchParamsData['business-id'];

      const rawUserId = searchParamsData['user-id'];

      const rawCompliancePolicy = searchParamsData['compliancePolicy'] as
        | string
        | undefined;

      const ottParam = Array.isArray(rawOtt) ? rawOtt[0] : rawOtt;

      const redirectUrlParam = Array.isArray(rawRedirect)
        ? rawRedirect[0]
        : rawRedirect;

      const roleParam = Array.isArray(rawRole) ? rawRole[0] : rawRole;

      const businessIdParam = Array.isArray(rawBusinessId)
        ? rawBusinessId[0]
        : rawBusinessId;

      const userIdParam = Array.isArray(rawUserId) ? rawUserId[0] : rawUserId;

      const compliancePolicyParam = isValidCompliancePolicy(rawCompliancePolicy)
        ? rawCompliancePolicy
        : null;

      const result = await loginUserAction({
        ottParam,
        redirectUrlParam,
        roleParam,
        businessIdParam,
        userIdParam,
        compliancePolicyParam,
      });

      if (result?.redirectUrl) {
        router.replace(result.redirectUrl);
      }
    };

    performLogin();
  }, [searchParams, router]);

  return null;
}
